import React from 'react';
import MuiToolbar, { ToolbarProps as MuiToolbarProps } from '@mui/material/Toolbar';

export type ToolbarProps = MuiToolbarProps;

const Toolbar = React.forwardRef<React.ElementRef<typeof MuiToolbar>, ToolbarProps>(
  function Toolbar(props, ref) {
    return <MuiToolbar ref={ref} {...props} />;
  },
);

export default Toolbar;
